"use client";

import React, { useState } from "react";
import Image from "next/image";
import styles from "./TestimonialsSection.module.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import type { Swiper as SwiperType } from "swiper";

import "swiper/css";
import "swiper/css/navigation";

import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Container, Row, Col } from "react-bootstrap";
import user1 from "@/app/assets/user1.png";
import user2 from "@/app/assets/user2.png";
import Ctest from "@/app/assets/ctest.svg";

const data = [
  {
    stars: "★★★★★",
    text: "We were expanding fast but struggling with fragmented systems. Thanks to them, we entered three new European markets in under six months.",
    img: user1,
    name: "Markus Vogel",
    role: "Founder & CEO",
  },
  {
    stars: "★★★★★",
    text: "Partnering with Temok was a game-changer. They helped us streamline workflows across three departments and reduced our operational overhead significantly.",
    img: user2,
    name: "Lena Carter",
    role: "COO",
  },
  {
    stars: "★★★★★",
    text: "Temok provided reliable support and a seamless experience that allowed us to grow without worrying about tech limitations.",
    img: user1,
    name: "James Robert",
    role: "Product Manager",
  },
  {
    stars: "★★★★★",
    text: "Their solutions scaled perfectly with our operations, and the customer support exceeded expectations.",
    img: user2,
    name: "Maria Steven",
    role: "CTO",
  },
];

const TestimonialsSection = () => {
  const [current, setCurrent] = useState(1);
  const [swiperRef, setSwiperRef] = useState<SwiperType | null>(null);

  const handlePrev = () => {
    swiperRef?.slidePrev();
  };

  const handleNext = () => {
    swiperRef?.slideNext();
  };

  return (
    <section className={styles.wrapper}>
      <div className="container">
      <Container className={styles.headerContainer}>
        <Row className="align-items-center justify-content-between">

          <Col lg={3} md={4} sm={12} className="d-flex align-items-center mb-3 mb-md-0">
            <Image src={Ctest} width={20} alt="icon" className="me-2" />
            <span className={styles.headerTitle}>Customers Feedback</span>
          </Col> 
        </Row>
        <div className={styles.bottomLine}></div>
      </Container>
        {/* TOP HEADER */}
        <div className={styles.topBar}>
          {/* LEFT SIDE */}
          <div> 
            <h2 className={styles.mainTitle}>What our clients think</h2>

            {/* PAGE COUNTER */}
            <div className={styles.counterRow}>
              <span className={styles.currentNum}>
                {String(current).padStart(2, "0")}
              </span>
              <span className={styles.total}>
                / {String(data.length).padStart(2, "0")}
              </span>
            </div>
          </div>

          {/* RIGHT SIDE: TEXT + ARROWS */}
          <div className={styles.rightSideWrapper}>
            <p className={styles.rightText}>
              Hear from the businesses that trust us to elevate their growth,
              simplify operations, and scale globally.
            </p>

            {/* TOP-RIGHT ARROWS */}
            <div className={styles.arrowsTop}>
              <button
                type="button"
                className={styles.arrowTopBtn}
                onClick={handlePrev}
              >
                <FaChevronLeft size={13} />
              </button>
              <button
                type="button"
                className={styles.arrowTopBtn}
                onClick={handleNext}
              >
                <FaChevronRight size={13} />
              </button>
            </div>
          </div>
        </div>

        {/* SWIPER */}
        <Swiper
          modules={[Navigation]}
          onSwiper={(swiper) => setSwiperRef(swiper)}
          slidesPerView={2}
          spaceBetween={25}
          onSlideChange={(swiper) => setCurrent(swiper.realIndex + 1)}
          breakpoints={{
            320: { slidesPerView: 1 },
            992: { slidesPerView: 2 },
          }}
        >
          {data.map((item, index) => (
            <SwiperSlide key={index}>
              <div className={styles.card}>
                <div className={styles.stars}>{item.stars}</div>

                <p className={styles.desc}>{item.text}</p>

                <div className={styles.userRow}>
                  <Image
                    src={item.img}
                    width={48}
                    height={48}
                    alt="User"
                    className={styles.avatar}
                  />
                  <div>
                    <h4 className={styles.userName}>{item.name}</h4>
                    <span className={styles.userRole}>{item.role}</span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default TestimonialsSection;
